export default __webpack_public_path__ + "static/media/checkmark-half.4c8fb902.svg";